export const LIST_AI_GOVERNANCE_TASKS = `
  query ListAIGovernanceTasks($status: String) {
    listAIGovernanceTasks(status: $status) {
      taskId
      taskType
      modelId
      modelArn
      accountId
      accountName
      region
      scopeKey
      status
      rationale
      sla
      componentId
      workloadId
      cliCommands
      cfnTemplate
      consoleLinks
      developerHandoff
      createdAt
      createdBy
      implementedAt
      implementedBy
    }
  }
`
